<template>
  <div>
    <v-form ref="form2" class="multi-col-validation">
      <v-select
        v-if="type==='Equipment'"
        v-model="equipment"
        class="mx-2"
        dense
        outlined
        label="Equipment"
        :items="equipment_items"
        item-value="equipment"
        item-text="equipment"
        @change="selected_equipment"
        :rules="rules.combobox_rule"
      ></v-select>
      <v-select
        v-model="equipment_brand_description"
        class="mx-2"
        dense
        outlined
        label="Code"
        :items="equipment_brand_description_items"
        item-value="equipment_brand_description"
        item-text="equipment_brand_description"
        @change="selected_equipment_brand_description"
        :rules="rules.combobox_rule"
      ></v-select>
      <v-select
        v-model="equipment_model_color1"
        class="mx-2 mb-9"
        dense
        outlined
        label="Specify"
        :items="equipment_model_color_items"
        item-value="id"
        item-text="details"
        @change="selected_equipment_model_color"
        :rules="rules.combobox_rule"
      ></v-select>
      <v-text-field
        readonly
        class="mx-2"
        v-model="equipment_serial_no"
        label="Serial #"
        dense
        outlined
        :rules="rules.default_max_45_character_and_no_empty_rule"
      ></v-text-field>
      <v-text-field
        readonly
        class="mx-2"
        v-model="equipment_model_color"
        label="Description"
        dense
        outlined
        :rules="rules.default_max_45_character_and_no_empty_rule"
      ></v-text-field>
      <v-text-field
        type="date"
        class="mx-2"
        v-model="equipment_date_release"
        label="Date Released"
        dense
        outlined
        :rules="rules.default_max_45_character_and_no_empty_rule"
      ></v-text-field>
      <v-text-field
        readonly
        class="mx-2"
        v-model="equipment_unit_price"
        label="Unit Price"
        dense
        outlined
        :rules="rules.default_max_45_character_and_no_empty_rule"
        type="number"
        min="0"
      ></v-text-field>
      <v-text-field
        class="mx-2"
        v-model="equipment_unit_quantity"
        label="Unit Quantity"
        dense
        outlined
        :rules="rules.default_max_45_character_and_no_empty_rule"
        type="number"
        min="0"
      ></v-text-field>
      <v-col cols="12" v-show="alert">
        <v-alert
          color="warning"
          text
          class="mb-0"
        >
          <div class="d-flex align-start">
            <v-icon color="warning">
              {{ icons.mdiAlertOutline }}
            </v-icon>

            <div class="ms-3">
              <p class="text-base font-weight-medium mb-1">
                {{alert_message}}
              </p>
            </div>
          </div>
        </v-alert>
      </v-col>
      <v-col cols="12" md="12">
        <v-btn
          class="w-full"
          color="primary"
          @click="save_request"
          v-if="!saving_data"
        >
          Save Changes
        </v-btn>
        <v-progress-circular
          :size=50
          :width="5"
          color="primary"
          indeterminate
          v-else
        ></v-progress-circular>
      </v-col>
    </v-form>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import {mdiCheck, mdiClose} from "@mdi/js";
  import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

  const initialState = () => {
    return {
      saving_data: false,
      alert: false,
      alert_message: '',

      equipment_unit_quantity: '0',
      equipment_unit_price: '0',
      equipment_model_color1: '',
      equipment_model_color: '',
      equipment_serial_no: '',
      equipment_brand_description: '',
      equipment_model_color: '',
      equipment_date_release: '',
      equipment: '',
      type: 'Equipment',

      equipment_brand_description_items: [],
      equipment_model_color_items: [],
      equipment_date_release_items: [],
      equipment_items: [],

      equipment_data: {},
    }
  }
  export default {
    components: {
      snackBarDialog,
    },
    data() {
      return initialState()
    },
    setup() {
      return {
        icons: {
          mdiCheck,
          mdiClose,
        },
      }
    },
    mounted() {
      this.initialize_data()
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
      ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    },
    props: {
      type_of_request: Number,

      transmital_no: Number,
      category_id: Number,
      branch_id: Number,
    },
    methods: {
      ...mapActions('system_data', ['change_snackbar']),
      ...mapActions('inventory', ['list_of_stocks', 'list_of_stocks_equipment_details', 'list_of_stocks_equipment_details_color', 'released_stock']),
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      initialize_data() {
        this.equipment = ''
        this.list_of_stocks({
          inventory_particulars_id: this.type_of_request,
        })
          .then(response => {
            this.equipment_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      selected_equipment_brand_description() {
        this.equipment_serial_no = ''
        this.equipment_model_color = ''
        this.equipment_unit_price = '0'
        this.equipment_unit_quantity = '0'
        this.list_of_stocks_equipment_details_color({
          inventory_particulars_id: this.type_of_request,
          equipment: this.equipment,
          equipment_brand_description: this.equipment_brand_description,
        })
          .then(response => {
            this.equipment_model_color_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      selected_equipment_model_color(value) {
        var index = this.equipment_model_color_items.map(function (x) {
          return x.id;
        }).indexOf(value)
        if (index != -1) {
          this.equipment_data = this.equipment_model_color_items[index].data

          this.equipment_serial_no = this.equipment_data.equipment_serial_no
          this.equipment_model_color = this.equipment_data.equipment_model_color
          this.equipment_unit_price = this.equipment_data.equipment_unit_price
          this.equipment_unit_quantity = '1'
        }
      },
      selected_equipment() {
        this.equipment_brand_description = ''
        this.equipment_serial_no = ''
        this.equipment_model_color = ''
        this.equipment_unit_price = '0'
        this.equipment_unit_quantity = '0'

        this.equipment_model_color1 = ''
        this.equipment_model_color_items = []
        this.list_of_stocks_equipment_details({
          inventory_particulars_id: this.type_of_request,
          equipment: this.equipment,
        })
          .then(response => {
            this.equipment_brand_description_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      selected_car_brand() {

      },
      async save_request() {
        this.saving_data = true
        this.alert = false

        if (this.$refs.form2.validate() && this.category_id > 0 && this.branch_id > 0) {
          const data = new FormData()
          data.append('inventory_id', this.equipment_model_color1);
          data.append('inventory_particulars_id', this.type_of_request);
          data.append('equipment_unit_quantity', this.equipment_unit_quantity);
          data.append('equipment_date_release', this.equipment_date_release);

          data.append('transmital_no', this.transmital_no);
          data.append('category_id', this.category_id);
          data.append('branch_id', this.branch_id);
          this.released_stock(data)
            .then(response => {
              var color = 'error'
              if (response.status === 200) {
                var color = 'success'
              }
              this.change_snackbar({
                show: true,
                color: color,
                text: response.data,
              })
              this.saving_data = false
            })
            .catch(error => {
              console.log(error)
            })
          await this.initialize_data()
          await this.selected_equipment()
          await this.selected_equipment_brand_description()
          this.$emit('data', true)
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_data = false
        }
      },
    }
  }
</script>
